export default () => {

  $('.tematic-grouper .grouper .post .header-title-wrapper .info-icon').off('click').click(function() {
    $(this).parents('.post').toggleClass('openedInfo');
    $(this).toggleClass('fa-times-circle fa-question-circle');
  });

}
